import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { gritUniversalInitialize } from './app-initialize';

import {
	GritWcAccordion,
	GritWcAnalytics,
	GritWcAutocomplete,
	GritWcAutocompleteItem,
	GritWcAutocompleteMessage,
	GritWcBadge,
	GritWcButton,
	GritWcCalendar,
	GritWcCalendarActions,
	GritWcCalendarBoard,
	GritWcCalendarField,
	GritWcCard,
	GritWcCheckbox,
	GritWcCheckboxGroup,
	GritWcChip,
	GritWcClipboardCard,
	GritWcField,
	GritWcFieldIcon,
	GritWcFieldMessage,
	GritWcIcon,
	GritWcIconButton,
	GritWcInPageNavigation,
	GritWcLinearLoader,
	GritWcListSelect,
	GritWcListSelectItem,
	GritWcLoaderMessage,
	GritWcMessage,
	GritWcMessageGroup,
	GritWcMoireCard,
	GritWcNotification,
	GritWcNotificationAction,
	GritWcNotificationFlag,
	GritWcOptionSelect,
	GritWcOptionSelectElement,
	GritWcOverlayContainer,
	GritWcPicker,
	GritWcProgLogo,
	GritWcQrCode,
	GritWcRadio,
	GritWcRadioGroup,
	GritWcSkeletonItem,
	GritWcSkiplink,
	GritWcSlider,
	GritWcSpinner,
	GritWcStep,
	GritWcStepper,
	GritWcSwitch,
	GritWcTopNavBar,
	GritWcValidationMessageItem,
	GritWcValidationMessageList,
	IconButtonDemo
} from './lib/proxies';

import { BooleanValueAccessor } from './lib/boolean-value-accessor';
import { NumericValueAccessor } from './lib/number-value-accessor';
import { SelectValueAccessor } from './lib/select-value-accessor';
import { TextValueAccessor } from './lib/text-value-accessor';

const COMPONENTS = [
	GritWcAccordion,
	GritWcAnalytics,
	GritWcAutocomplete,
	GritWcAutocompleteItem,
	GritWcAutocompleteMessage,
	GritWcBadge,
	GritWcButton,
	GritWcCalendar,
	GritWcCalendarActions,
	GritWcCalendarBoard,
	GritWcCalendarField,
	GritWcCard,
	GritWcCheckbox,
	GritWcCheckboxGroup,
	GritWcChip,
	GritWcClipboardCard,
	GritWcField,
	GritWcFieldIcon,
	GritWcFieldMessage,
	GritWcIcon,
	GritWcIconButton,
	GritWcInPageNavigation,
	GritWcLinearLoader,
	GritWcListSelect,
	GritWcListSelectItem,
	GritWcLoaderMessage,
	GritWcMessage,
	GritWcMessageGroup,
	GritWcMoireCard,
	GritWcNotification,
	GritWcNotificationAction,
	GritWcNotificationFlag,
	GritWcOptionSelect,
	GritWcOptionSelectElement,
	GritWcOverlayContainer,
	GritWcPicker,
	GritWcProgLogo,
	GritWcQrCode,
	GritWcRadio,
	GritWcRadioGroup,
	GritWcSkeletonItem,
	GritWcSkiplink,
	GritWcSlider,
	GritWcSpinner,
	GritWcStep,
	GritWcStepper,
	GritWcSwitch,
	GritWcTopNavBar,
	GritWcValidationMessageItem,
	GritWcValidationMessageList,
	IconButtonDemo
];

const DECLARATIONS = [
  ...COMPONENTS,

  // NgModel accessors!
  BooleanValueAccessor,
  NumericValueAccessor,
  SelectValueAccessor,
  TextValueAccessor,
];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  imports: [],
  providers: [],
})
export class GritUniversalModule {
  static forRoot(): ModuleWithProviders<GritUniversalModule> {
    return {
      ngModule: GritUniversalModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: gritUniversalInitialize,
          multi: true,
        },
      ],
    };
  }
}
